// extracted by mini-css-extract-plugin
export default {"inputAndGo":"ub44c"};